import React, { useState } from "react";
import { Mail, Loader2, X, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
const Chips = ({ list, bg, fg, testid }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testid}>
    {list.map((r) => <span key={r} className="px-2 py-0.5 rounded-full text-xs font-semibold" style={{ background: bg, color: fg }}>{r}</span>)}
  </div>
);

export const InviaInterventoButton = ({ it, onSent }) => {
  const [st, setSt] = useState(null);
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const sent = it.email_commessa;

  const openDialog = async () => {
    setOpen(true); setSt(null);
    try { const { data } = await api.get(`/interventi-lista/${it.id}/invia-commessa`); setSt(data); }
    catch (err) { toast.error(formatApiError(err)); setOpen(false); }
  };
  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post(`/interventi-lista/${it.id}/invia-commessa`);
      toast.success(`Intervento inviato a ${data.to.join(", ")}${data.cc.length ? ` (CC ${data.cc.join(", ")})` : ""}`);
      setOpen(false); onSent?.();
    } catch (err) { toast.error(formatApiError(err)); } finally { setSending(false); }
  };
  const blocker = st && (!st.smtp_configured ? "Invio email non configurato: Impostazioni → Email Aruba" : !st.recipients.length ? `Nessun indirizzo "Interventi" nella commessa ${st.commessa_nome || ""}` : "");

  return (
    <>
      <button onClick={openDialog} className="btn-secondary text-xs" title={sent ? `Inviato il ${fmt(sent.sent_at)}` : "Invia alla commessa"} data-testid={`interventi-invia-${it.id}`}>
        <Mail className="w-3.5 h-3.5" style={{ color: sent ? "#1B5E20" : undefined }} /> {sent ? "Reinvia" : "Invia"}
      </button>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,.4)" }} onClick={() => setOpen(false)}>
          <div className="bg-white rounded-xl w-full max-w-md text-left" onClick={(e) => e.stopPropagation()} data-testid={`interventi-invia-dialog-${it.id}`}>
            <div className="p-4 border-b flex items-center" style={{ borderColor: "var(--border)" }}>
              <h2 className="font-bold flex-1">Invia intervento alla commessa</h2>
              <button onClick={() => setOpen(false)} className="p-1 rounded hover:bg-black/5"><X className="w-4 h-4" /></button>
            </div>
            {!st ? <div className="p-6 flex justify-center"><Loader2 className="w-5 h-5 animate-spin" /></div> : (
              <div className="p-4 space-y-3 text-sm">
                <div className="text-[11px] font-semibold uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>Destinatari · {st.commessa_nome}</div>
                {st.recipients.length > 0 && <Chips list={st.recipients} bg="#E8F5E9" fg="#1B5E20" testid="interventi-invia-recipients" />}
                {st.cc.length > 0 && <div className="flex items-center gap-1.5"><span className="text-[11px] font-semibold" style={{ color: "var(--text-muted)" }}>CC</span><Chips list={st.cc} bg="#F1F5F9" fg="#334155" testid="interventi-invia-cc" /></div>}
                <div className="text-xs" style={{ color: "var(--text-muted)" }}>Allegato: PDF con dati dell'intervento, descrizione, note e foto.</div>
                {st.last_sent && <div className="text-xs p-2 rounded" style={{ background: "var(--surface-muted)" }}>Ultimo invio: {fmt(st.last_sent.sent_at)} da {st.last_sent.sent_by_name}</div>}
                {blocker && <div className="text-xs p-2 rounded" style={{ background: "#FFF3E0", color: "#8D3B00" }} data-testid="interventi-invia-blocker">{blocker}</div>}
                <div className="flex justify-end gap-2 pt-1">
                  <button onClick={() => setOpen(false)} className="btn-secondary">Annulla</button>
                  <button onClick={send} disabled={!!blocker || sending} className="btn-primary disabled:opacity-50" data-testid={`interventi-invia-confirm-${it.id}`}>
                    {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Invia
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
